import {SlSwitch} from '@shoelace-style/shoelace/shoelace';

export class PreviewFeatureSwitch {
    private readonly apiurl: string = '/previewfeature/api_change/';

    constructor() {
        this.initializeEvent();
    }

    private initializeEvent(): void {
        const switcher = document.getElementById('previewFeatureSwitcher') as SlSwitch;
        if (!switcher) {
            return;
        }

        switcher.addEventListener('sl-change', (event) => {
            const element = event.target as SlSwitch;

            const data = new FormData();
            data.append('previewFeatureSwitch', element.checked ? 'on' : 'off');

            const myInit: RequestInit = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: data,
                cache: 'default',
                credentials: 'same-origin',
            };

            fetch(this.apiurl, myInit)
                .then((response) => response.json())
                .then((json) => {
                    if (json.success && json.success === true) {
                        window.location.reload();
                    }
                });
        });
    }
}
